export default __webpack_public_path__ + "static/media/pairs.6f010e99.svg";